<template>
  <div id="btlogo" class="modal-footer" :class="cartProducts.length || selectedSeat ? 'custom-margin' : ''">
    <div class="powered-by">
      <h5 v-if="pdv === 100" class="checkout-h5">TECNOLOGIA</h5>
      <blueticket-logo v-if="pdv === 100" />
    </div>
    <div class="security">
      <h5 class="checkout-h5">COMPRA PROTEGIDA</h5>
      <svg
        fill="#979797"
        style="margin-top:-10px"
        version="1.1"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          d="M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,7C13.4,7 14.8,8.1 14.8,9.5V11C15.4,11 16,11.6 16,12.3V15.8C16,16.4 15.4,17 14.7,17H9.2C8.6,17 8,16.4 8,15.7V12.2C8,11.6 8.6,11 9.2,11V9.5C9.2,8.1 10.6,7 12,7M12,8.2C11.2,8.2 10.5,8.7 10.5,9.5V11H13.5V9.5C13.5,8.7 12.8,8.2 12,8.2Z"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BlueticketLogo from '../UI/logo/BlueticketLogo';

export default {
  components: { BlueticketLogo },
  computed: {
    ...mapGetters(['pdv']),
    cartProducts() {
      return this.$store.getters.cartProducts;
    },
    selectedSeat() {
      return this.$store.getters.selectedSeat;
    },
  }
};
</script>
<style scoped>
.custom-margin {
  margin-bottom: 80px;
}
</style>
<style lang="stylus" scoped>
@import "~@/assets/modal/modalFooter.styl"
</style>
